import React from 'react';
export function TopBar() {
  return <div className="hidden md:flex items-center justify-center px-4 py-1 w-full" style={{
    backgroundColor: '#162e22',
    borderBottom: '1px solid rgba(200,168,75,0.2)'
  }} data-id="element-212">
      <span style={{
      color: '#a0b8a8',
      fontFamily: 'Inter, sans-serif',
      fontSize: '13px',
      textAlign: 'center'
    }} data-id="element-213">
        A Member‑supported shooting sports club in Fenton, Michigan—ranges,
        sporting clays, archery, and training since 1953.
      </span>
    </div>;
}